import React, { useMemo } from 'react';
import Timeline from '../../components/Timeline/Timeline';
import ServiceRequestTabs from './ServiceRequestTabs';
import ServiceRequestOverlays from './ServiceRequestOverlays';
import { useSelector } from 'react-redux';
import { useServiceRequestDataFromContext } from 'src/pages/ServiceRequest/Context/ServiceRequestContext';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';

interface ServiceRequestContentProps {
  requestId: string;
  activeTab: number;
  history: any;
  state: any;
  setState: (state: any) => void;
  onSubmitPopup: (type: string, data: any) => void;
  handleStatusAssign: (statusFormData: any, serviceRequestId: string) => void;
  handleSaveScheduledAppointment: (
    formData: any,
    serviceRequestId: string
  ) => void;
  refreshData: () => void;
  matchId: string;
}

const ServiceRequestContent = ({
  requestId,
  activeTab,
  history,
  state,
  setState,
  onSubmitPopup,
  handleStatusAssign,
  handleSaveScheduledAppointment,
  refreshData,
  matchId,
}: ServiceRequestContentProps) => {
  const notesList = useSelector((state: any) => state.notes);
  const user = useSelector((state: any) => selectAuthenticatedUser(state));
  const { serviceRequest, loading } = useServiceRequestDataFromContext();

  const { noteVisibleToHomeownerOccupantRealtor } = useMemo(() => {
    const notesData: any[] = [];
    let visible: boolean = false;

    if (notesList?.length > 0) {
      const filteredNotes = notesList.filter((x: any) => x.type === 'NOTES');

      filteredNotes.forEach((object: any) => {
        notesData.push(JSON.parse(JSON.parse(JSON.stringify(object.data))));
      });

      if (notesData.length > 0) {
        visible = notesData.some(
          (x: any) => x.noteVisibleToHomeownerOccupantRealtor === true
        );
      }
    }

    return {
      noteVisibleToHomeownerOccupantRealtor: visible,
      HmeOwnrOcpntRltrNotes: notesData,
    };
  }, [notesList]);

  return (
    <div className="serviceRequest">
      <div className="serviceRequest__timeline">
        <Timeline activity={serviceRequest.activity || []} loading={loading} />
      </div>
      <ServiceRequestTabs
        user={user}
        requestId={requestId}
        activeTab={activeTab}
        history={history}
        noteVisibleToHomeownerOccupantRealtor={
          noteVisibleToHomeownerOccupantRealtor
        }
        matchId={matchId}
      />
      <ServiceRequestOverlays
        state={state}
        setState={setState}
        refreshData={refreshData}
        handleSaveScheduledAppointment={handleSaveScheduledAppointment}
        handleStatusAssign={handleStatusAssign}
        onSubmitPopup={onSubmitPopup}
      />
    </div>
  );
};

export default ServiceRequestContent;
